import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useOutletContext } from 'react-router-dom';

import BreadcrumbTrail from '../../../../layouts/BreadcrumbTrail';
import CenteredLoader from '../../../../components/loaders/PageLoader';

import { useMeterVersions } from '../../hooks/useMeterVersions';
import MeterVersionTable from '../../components/MeterVersion/MeterVersionTable';
import styles from './MeterVersion.styles';

import { useCrumb } from '../../../../layouts/TrailProvider';

export default function MeterVersion() {
  const { isSidebarExpanded } = useOutletContext();
  const { meterNumber } = useParams();

  useCrumb('History', `/home/meters/${encodeURIComponent(meterNumber)}/history`);

  const { loading, versions } = useMeterVersions(meterNumber);

  return (
    <Box
      sx={{
        ...styles.versionDetails,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      <BreadcrumbTrail />

      <Box sx={styles.headerRow}>
        <Typography sx={styles.pageTitle}>Meter History – {meterNumber}</Typography>
      </Box>

      {loading ? (
        <CenteredLoader />
      ) : (
        <MeterVersionTable rows={versions} />
      )}
    </Box>
  );
}
